// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__iTuHV","image":"App_image__1V-Na","footer":"App_footer__9ALln"};